import { State, Action, StateContext, Store, Selector } from '@ngxs/store';

const category = 'Query';

export interface SpanType {
    field: string;
    display: string;
    value: boolean;
}
export class SetAvailableSpanTypes {
    static readonly type = `[${category}] ChangeStatus`;
    constructor(public spanTypes: SpanType[]) {}
}

export class SetSelectedSpanTypes {
    static readonly type = `[${category}] SetSelectedSpanTypes`;
    constructor(public SelectedSpanType: string[]) {}
}

interface IQueryState {
    availableSpanTypes: SpanType[];
    selectedSpanTypes: string[];
}

@State<IQueryState>({
    name: 'query',
    defaults: {
        availableSpanTypes: [],
        selectedSpanTypes: ['ALL'],
    },
})
export class QueryState {
    constructor(private store: Store) {}

    // available spans state
    @Selector([QueryState])
    static availableSpanTypes(state: IQueryState) {
        return state.availableSpanTypes;
    }

    @Action(SetAvailableSpanTypes)
    setAvailableSpanTypes(ctx: StateContext<IQueryState>, action: SetAvailableSpanTypes) {
        ctx.patchState({
            availableSpanTypes: action.spanTypes,
        });
    }

    // selected spans state
    @Selector([QueryState])
    static selectedSpanTypes(state: IQueryState) {
        return state.selectedSpanTypes;
    }

    @Action(SetSelectedSpanTypes)
    setSelectedSpanTypes(ctx: StateContext<IQueryState>, action: SetSelectedSpanTypes) {
        ctx.patchState({
            selectedSpanTypes: action.SelectedSpanType,
        });
    }

    getAvailableSpanTypes() {
        return this.store.selectSnapshot(QueryState.availableSpanTypes);
    }

    getSelectedSpanTypes() {
        return this.store.selectSnapshot(QueryState.selectedSpanTypes);
    }
}
